<div class="container p-mt-5">
  <div class="row1">
    <div class="first-name">
      <dx-text-box
        id="firstName"
        [style]="{ width: '225px' }"
        placeholder="First name"
        [(value)]="firstName"
        >
      </dx-text-box>

    </div>
    <div class="last-name">
      <dx-text-box
        id="lastName"
        [style]="{ width: '225px' }"
        placeholder="Last name"
        [(value)]="lastName"
        >
      </dx-text-box>

    </div>
    <div class="mobile-number">
      <dx-text-box
        id="mobileNumber"
        [style]="{ width: '225px' }"
        placeholder="Mobile number"
        [(value)]="mobileNumber"
        >
      </dx-text-box>

    </div>
  </div>
  <div class="row2">
    <div class="email-address">

      <div title="Government ID / Passport number" class="gov-pass-id">
        <input
          [(ngModel)]="identityNumber"
          type="text"
          pInputText
          placeholder="Identity number"
          class="p-inputtext-sm"
          [style]="{ width: '225px' }"
        />
      </div>
      <div class="user-role">

      </div>
    </div>
    <div class="row3">
      <div class="business-name">

      </div>
      <div class="product">

      </div>
      <div class="search-btn">

      </div>
    </div>
  </div>
</div>
